import { Button } from "@/components/ui/button";
import { MessageCircle, Menu } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary/80 backdrop-blur-md border-b border-white/10">
      <div className="container mx-auto px-4">
        <div className="relative flex items-center justify-between h-20">
          {/* Logo and Company Name */}
          <div className="flex items-center space-x-3">
            <Link to="/">
              <img 
                src="/lovable-uploads/531d85c9-4e8f-4fdb-ace1-a7c3d73382a6.png" 
                alt="AutoMate Labs Mascot" 
                className="h-11 w-11 object-contain"
              />
            </Link>
            <Link to="/" className="text-white font-bold text-2xl font-serif">
              AutoMate Labs
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <Link to="/" className="text-white/90 hover:text-white px-3 py-2">
              Início
            </Link>
            <Link to="/privacy-policy" className="text-white/90 hover:text-white px-3 py-2">
              Política de Privacidade
            </Link>
            <Link to="/terms-of-use" className="text-white/90 hover:text-white px-3 py-2">
              Termos de Uso
            </Link>
            <Button 
              onClick={() => window.open('https://wa.me/556292060092', '_blank')}
              className="bg-whatsapp hover:bg-whatsapp/90"
            >
              <MessageCircle className="mr-2 h-4 w-4" />
              WhatsApp
            </Button>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              className="text-white"
              onClick={toggleMobileMenu}
            >
              <Menu className="h-6 w-6" />
            </Button>
          </div>

          {/* Mobile menu */}
          <div
            className={`${
              isMobileMenuOpen ? "block" : "hidden"
            } md:hidden absolute top-full left-0 right-0 bg-primary/95 backdrop-blur-md border-b border-white/10`}
          >
            <div className="p-4 space-y-3">
              <Link
                to="/"
                className="block text-white/90 hover:text-white px-3 py-2"
              >
                Início
              </Link>
              <Link
                to="/privacy-policy"
                className="block text-white/90 hover:text-white px-3 py-2"
              >
                Política de Privacidade
              </Link>
              <Link
                to="/terms-of-use"
                className="block text-white/90 hover:text-white px-3 py-2"
              >
                Termos de Uso
              </Link>
              <Button
                onClick={() => window.open('https://wa.me/556292060092', '_blank')}
                className="w-full bg-whatsapp hover:bg-whatsapp/90"
              >
                <MessageCircle className="mr-2 h-4 w-4" />
                WhatsApp
              </Button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};